import React, { FC } from "react";  
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import { DescriptionCell, LabelCell, PropertyButtons } from "../../../../shared/styles";
import { ReOrderSttingsRequest } from "../../../../shared/models";
import { ItemReOrderIntervals } from "../../../../shared/enums";

type IProps = {
  reOrderSettings?: ReOrderSttingsRequest;
  allowReOrder: boolean;
};

const ItemReOrderSection: FC<IProps> = ({ reOrderSettings, allowReOrder }) => {
  const row = (
    label: string,
    rightColumn: string | React.ReactNode
  ): React.ReactNode => {
    return (
      <FlexContainer className="label-description-row">
        <LabelCell className="reduced-width">
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  };

  return (
    <>
      <CustomLabel fontSize="20px" fontWeight="600" margin="50px 0px 30px">
        Reorder
      </CustomLabel>
      {row(
        "Re-Order & Save",
        <CustomLabel>{allowReOrder ? "Yes" : "No"}</CustomLabel>
      )}
      {reOrderSettings &&
        row(
          "Available  Reorder Frequencies",

          <div>
            <FlexContainer spacing={8} fxWrap="wrap">
              {reOrderSettings?.reOrderIntervals?.map((r, idx) => {
                return (
                  <PropertyButtons
                    key={idx}
                    minWidth="70px"
                    width="auto"
                    maxWidth="200px"
                  >
                    {
                      ItemReOrderIntervals[
                        r as keyof typeof ItemReOrderIntervals
                      ]
                    }
                  </PropertyButtons>
                );
              }) || "-"}
            </FlexContainer>
          </div>
        )}
      {reOrderSettings &&
        row(
          "Discount Offered",
          <CustomLabel>
            {!reOrderSettings ? "-" : reOrderSettings?.discountPercentage + "%"}
          </CustomLabel>
        )}
    </>
  );
};
export default ItemReOrderSection;
